(function() {
  function pdpTabs() {
    const ELM_tabs = document.querySelectorAll('[pdp-tab]');
    if (!ELM_tabs) return;
    const ELM_tabContents = document.querySelectorAll('[pdp-tab-content]');

    ELM_tabs.forEach(ELM_tab => {
      ELM_tab.addEventListener('click', () => {
        if (ELM_tab.classList.value.includes('active')) return;

        const val = ELM_tab.getAttribute('pdp-tab');
        document.querySelector('[pdp-tab].active')?.classList.remove('active');
        ELM_tab.classList.add('active');
        ELM_tabContents.forEach(ELM_tabContent => {
          if (ELM_tabContent.getAttribute('pdp-tab-content') === val) {
            ELM_tabContent.classList.remove('hidden');
          } else {
            ELM_tabContent.classList.add('hidden');
          }
        })
      })
    })
  }

  function pdpTabsSticky() {
    const ELM_pdpTabs = document.querySelector('.pdp-tabs');
    if (!ELM_pdpTabs) return;

    const positionTop = ELM_pdpTabs.getBoundingClientRect().top + window.scrollY;
    
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      const height = ELM_pdpTabs.getBoundingClientRect().height;
      const headerHeight = document.querySelector('header.header')?.getBoundingClientRect().height || 84;
      
      if (scrollTop >= positionTop + headerHeight + height) {
        ELM_pdpTabs.classList.add('sticky');
      } else {
        ELM_pdpTabs.classList.remove('sticky');
      }
    })
  }

  function showHideTabs() {
    const ELM_tabs = document.querySelectorAll('[pdp-tab]');
    if (!ELM_tabs) return;

    let count = 0;
    ELM_tabs.forEach(ELM_tab => {
      const val = ELM_tab.getAttribute('pdp-tab');
      if (document.querySelector(`[pdp-tab-content="${val}"]`)) {
        count += 1;
      } else {
        ELM_tab.style.display = 'none';
      }
    })

    if (count < 2) {
      if (document.querySelector('.pdp-tabs')) {
        document.querySelector('.pdp-tabs').style.display = 'none';
      }
    }
  }

  pdpTabs();
  pdpTabsSticky();
  showHideTabs();
})();

class ProductDescription extends HTMLElement {
  constructor() {
    super();
    const height = this.getBoundingClientRect().height;
    const maxHeight = this.dataset.maxHeight ? Number(this.dataset.maxHeight) : 100;
    this.ELM_more = this.querySelector('.product-description-more');
    this.ELM_moreButton = this.querySelector('.product-description-more-button');

    if (height > maxHeight) {
      this.uncollapse();
    }

    this.ELM_moreButton.addEventListener('click', this.collapse.bind(this));
  }

  collapse() {
    this.ELM_more.classList.add('hidden');
    this.classList.add('collapsed');
  }

  uncollapse() {
    this.ELM_more.classList.remove('hidden');
    this.classList.remove('collapsed');
  }
}
customElements.define('product-description', ProductDescription);

class LookHotspot extends HTMLElement {
  constructor() {
    super();
    this.ELM_container = this.closest('.section-pdp-lookbook');
    this.ELM_closeButton = this.querySelector('.look__hotspot-product__close-button');

    this.addEventListener('click', e => {
      if (this.ELM_closeButton.contains(e.target)) return;
      this.open();
    });

    this.ELM_closeButton.addEventListener('click', () => this.close());
  }

  open() {
    this.classList.add('active');
    this.ELM_container.classList.add('lookbook--open');
    document.body.classList.add('lookbook--open');
  }

  close() {
    this.classList.remove('active');
    this.ELM_container.classList.remove('lookbook--open');
    document.body.classList.remove('lookbook--open');
  }
}
customElements.define('look-hotspot', LookHotspot);